module.exports = __webpack_public_path__ + "static/media/truck-pickup.fa828c83.svg";